import { usePolledCount } from './usePolledCount.js';

/**
 * How many chats are waiting on a reply, while `enabled` (session ready + widget
 * closed).
 *
 * "Waiting on a reply" means someone else sent the last message. Reading does
 * not clear it, only replying does — which is what makes the nudge's wording
 * ("N chats need your reply") a promise it can keep. Answered from
 * stream-chat-backend's pre-aggregated table, so it costs no Stream call at all.
 *
 * Its sibling is `useUnreadCount`, which the badge now draws from. The two are
 * meant to disagree: an employer who reads everything and answers nothing has
 * nothing unread and plenty pending.
 */
export function usePendingReplies(enabled: boolean): number {
  return usePolledCount('/api/chat/pending-replies', enabled) ?? 0;
}
